import {ACCESS_RIGHT} from '../actions/const';

import moment from 'moment';

const initialState = {
  access: []
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case ACCESS_RIGHT:
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/accessJSON.js